import React, { useCallback } from 'react'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { BnblSteps } from 'components/OfferPage/BnblModal/utils'
import { pluralizeToString } from 'lib/string/pluralize'
import Group from 'components/utils/Group'

interface Props {
  duration: number;
  setStep: (step: BnblSteps) => void;
}

export function BnblPackageDuration({ duration, setStep }: Props) {
  const onChangeDuration = useCallback(() => {
    setStep(BnblSteps.CHANGE_DURATION)
  }, [setStep])

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
      <BodyText variant="large" weight="bold">Length of stay</BodyText>
      <TextLink onClick={onChangeDuration}>{pluralizeToString('night', duration)}</TextLink>
    </Group>
  )
}
